export enum VendorCodeType {
  COMMERCIAL = 'Commercial',
  DIRECT_MAIL = 'DirectMail',
  INTERNET = 'Internet',
}
